import axiosInstance from "./axiosConfig";

export const getManufacturers = () => {
    const config = {
        method: "GET",
        url: '/admin/list-Manufacturers/'
    }

    const res = axiosInstance(config).then((res) => {
        return res.data;
    }).catch((err) => {
        console.log("error in getManufacturers: ", err);
        return null;
    })

    return res;
}

export const deleteManufacturer = (email) => {
    const data = JSON.stringify({ "manufacturer_email": email });

    const config = {
        method: "DELETE",
        url: '/admin/delete-manufacturer/',
        headers: {
            "Content-Type": "application/json"
        },
        data: data,
    }

    const res = axiosInstance(config).then((res) => {
        return res.data;
    }).catch((err) => {
        console.log("error deleting manufacturer: ", err);
        return null;
    })

    return res;
}